{
    "Title": "CME-details",
    "SectionTitleDatetimevalues": "DATUM\/TIJD WAARDEN",
    "SectionTitleDeviceandacdinfo": "APPARAAT & ACD-INFORMATIE",
    "SectionTitleStatusvalues": "STATUSWAARDEN",
    "SectionTitleAssociatedtelephonyenv": "Instellingen voor centrale beheeromgeving.",
    "SectionTitleDiagnosticvalues": "DIAGNOSTISCHE WAARDEN",
    "ButtonHelp": "Helpen?",
    "ButtonClose": "Afsluiten",
    "ColumnHeaderValue": "Waarde",
    "ColumnHeaderFieldStatistic": "statistisch alarm",
    "ButtonCollapseall": "Alles inklappen",
    "NAME": "ACDDNDActivity"
}